<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Obiekty</div>

        <p>Lista obiektów partnera</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex text-xs-right pb-0>
        <check-permission permissions="PLACE.ADD" entityType="partner" :entityId="partnerId">
          <v-btn large color="error" @click="showAddModal">DODAJ OBIEKT</v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <material-table
      entity-type="place"
      :headers="table.headers"
      :actions="actions"
      :items="list"
      :total-count="count"
      @add="showAddModal"
      @edit="showEditModal($event.id)"
      @delete="deleteValidation($event.id)"
    />

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy na pewno chcesz usunąć obiekt? Usunięcie obiektu spowoduje usunięcie przypisanych do niego usług."
      :show="!!idToDelete"
      :id="idToDelete"
      @close="hideDeleteDialog"
      @confirm="remove"
    />

    <add :show="showModal" :id="idToEdit" @close="hideModal" @save="savePlace" @update="updatePlace" />
  </material-card>
</template>

<script>
import { address, SessionStorage } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import { DEFAULT_LIST_COUNT } from '@/utils/constants';
import Add from './modals/AddPlace.modal';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania listy obiektów.',
  getError: 'Wystąpił błąd podczas pobierania danych obiektów.',
  added: 'Dodano obiekt.',
  addError: 'Nie udało się dodać obiektu.',
  updated: 'Zaktualizowano dane obiektu.',
  updateError: 'Nie udało się zaktualizować danych obiektu.',
  deleted: 'Usunięto obiekt.',
  deleteError: 'Nie udało się usunąć obiektu.'
};

export default {
  components: {
    MaterialCard,
    Add,
    MaterialTable,
    MaterialDialog
  },
  mixins: [listMixin('partners/places', messages)],

  data() {
    return {
      table: {
        headers: [
          { value: 'name', text: 'Nazwa', sortable: true },
          { value: 'street', text: 'Adres', sortable: false, render: item => address(item) }
        ]
      },
      actions: [{ ...DELETE_ACTION, check: () => this.count > 1 }, EDIT_ACTION]
    };
  },
  computed: {
    ...mapState({
      partnerId: state => state.partners.id,
      list: state => state.partners.places.list,
      count: state => state.partners.places.count
    })
  },
  methods: {
    // @vuese
    // Zapisuje obiekt
    // @arg `place` - dane Obiektu
    savePlace(place) {
      try {
        this.$store
          .dispatch('partners/places/add', { place: this.deepClone(place), partnerId: this.partnerId })
          .then(() => {
            this.notifySuccess('Dodano obiekt.');
            this.hideModal();
          });
      } catch (error) {
        this.notifyError('Nie udało się dodać obiektu.');
      }
    },
    // @vuese
    // Aktualizuje obiekt
    // @arg `data` - dane Obiektu
    updatePlace(data) {
      const id = data.id;
      data.id = undefined;
      try {
        this.$store.dispatch('partners/places/update', { id, place: this.deepClone(data) }).then(() => {
          this.notifySuccess('Zaktualizowano dane obiektu.');
          this.hideModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się zaktualizować danych obiektu.');
      }
    },
    // Sprawdza czy można usunąc obiekt
    // @arg `id` - id obiektu
    deleteValidation(id) {
      if (this.count <= 1) {
        return this.notifyError('Partner musi posiadać chociaż jeden obiekt');
      }
      if (parseInt(localStorage.getItem(SessionStorage.PLACE_ID)) === id) {
        return this.notifyError('Nie można usunąć obiektu, który jest wybrany');
      }
      this.showDeleteDialog(id);
    },
    filters(pagination, route) {
      return { ...pagination, partnerId: parseInt(route.params.id) };
    }
  }
};
</script>
